export function getScrollLimitY() {
    const deviceWidth = window.innerWidth

    const tabletWidth = 768

    const mobileLimitY = 35
    const desktopLimitY = 60

    const currentLimitY = deviceWidth > tabletWidth ? desktopLimitY : mobileLimitY

    return currentLimitY
}
